import { render, staticRenderFns } from "./GroupCharts.vue?vue&type=template&id=af68dad8&"
import script from "./GroupCharts.vue?vue&type=script&lang=ts&"
export * from "./GroupCharts.vue?vue&type=script&lang=ts&"
import style0 from "./GroupCharts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports